var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLgArbitrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 105.799,
    viewBox: "0 0 94.235 105.799",
    width: 94.235,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m102.6 86.823 7.77-13.184 20.943 32.619.01 6.26-.068-43.076a3.245 3.245 0 0 0 -1.5-2.584l-37.703-21.688a3.322 3.322 0 0 0 -2.881.014 3.1 3.1 0 0 0 -.337.2l-.132.083-36.602 21.202-.142.064a3.309 3.309 0 0 0 -.54.315 3.255 3.255 0 0 0 -1.35 2.44l.058 35.1 19.509-30.232c2.456-4.009 7.807-5.3 12.774-5.23l5.83.154-34.351 55.09 4.049 2.331 34.763-57.365 15.365-.056-34.672 58.813 14.449 8.307 1.726.993a3.315 3.315 0 0 0 2.328.046l38.234-22.157-7.31 4.236zm2.964 42.7-14.594-22.9 8.912-15.123 19.166 30.21z",
    fill: "#2d374b",
    transform: "translate(-43.565 -38.347)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m237.768 274.032 14.594 22.905 13.481-7.813-19.167-30.21z",
    fill: "#28a0f0",
    transform: "translate(-190.36 -205.765)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m319.856 215.847-.01-6.26-20.946-32.619-7.77 13.184 20.217 32.7 7.31-4.236a3.24 3.24 0 0 0 1.2-2.359z",
    fill: "#28a0f0",
    transform: "translate(-232.097 -141.676)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m20.219 205.544 10.323 5.948 34.351-55.092-5.83-.154c-4.967-.07-10.318 1.221-12.774 5.23l-19.507 30.238-6.563 10.086z",
    fill: "#fff",
    transform: "translate(-20.219 -125.469)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m136.3 156.964-15.365.056-34.765 57.365 12.151 7 3.3-5.6z",
    fill: "#fff",
    transform: "translate(-71.798 -126.031)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m114.453 45.87a9.787 9.787 0 0 0 -4.594-7.87l-38.199-21.964a9.937 9.937 0 0 0 -8.764 0c-.319.161-37.147 21.52-37.147 21.52a9.776 9.776 0 0 0 -5.531 8.3v45.488l6.563-10.083-.057-35.1a3.127 3.127 0 0 1 .047-.379 3.232 3.232 0 0 1 1.3-2.061c.173-.124 37.63-21.806 37.749-21.865a3.323 3.323 0 0 1 2.881-.014l37.7 21.688a3.245 3.245 0 0 1 1.5 2.584v43.486a3.17 3.17 0 0 1 -1.127 2.359l-7.31 4.236-3.764 2.181-13.48 7.813-13.672 7.923a3.315 3.315 0 0 1 -2.328-.046l-16.176-9.3-3.3 5.6 14.536 8.369c.481.273.909.516 1.26.713.544.305.915.509 1.046.573a9.443 9.443 0 0 0 3.859.794 9.718 9.718 0 0 0 3.555-.669l39.71-23a9.709 9.709 0 0 0 3.741-7.314v-43.962z",
    fill: "#96bedc",
    transform: "translate(-20.218 -15.017)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgArbitrum);
export default __webpack_public_path__ + "static/media/lg_arbitrum.bdf133fe639951697f29d6c4b714cd08.svg";
export { ForwardRef as ReactComponent };